import React from 'react'
import clsx from 'clsx'

import SettingsSection from '../../SettingsSection'
import TypesMenu from '../../../../components/molecules/TypesMenu'

import { EXTERNAL_SETTING_KEY, INTERNAL_SETTING_KEY } from '..'
import useStyles from './styles'

const DefaultsSettings = ({ values, handleChange, configLoaded }) => {
  const classes = useStyles()

  return (
    <SettingsSection title='Defaults' loaded={configLoaded}>
      <div className={classes.dropdown}>
        <div className={classes.title}>External Default Contact Type</div>

        <TypesMenu
          testid='settings-defaults-external-contact-type'
          selected={values[EXTERNAL_SETTING_KEY]}
          onSelect={e => {
            handleChange(EXTERNAL_SETTING_KEY, e, false)
          }}
          className={clsx(classes.fieldValue, classes.type)}
          disabled={!configLoaded}
          hideInternal
          addSystemDefault
        />
      </div>
      <div className={classes.dropdown}>
        <div className={classes.title}>Internal Default Contact Type</div>

        <TypesMenu
          testid='settings-defaults-internal-contact-type'
          selected={values[INTERNAL_SETTING_KEY]}
          onSelect={e => {
            handleChange(INTERNAL_SETTING_KEY, e, false)
          }}
          className={clsx(classes.fieldValue, classes.type)}
          disabled={!configLoaded}
          hideExternal
          addSystemDefault
        />
      </div>
    </SettingsSection>
  )
}

export default DefaultsSettings
